import { render, staticRenderFns } from "./ForumArticles1.vue?vue&type=template&id=3fbaf2e6&scoped=true&"
import script from "./ForumArticles1.vue?vue&type=script&lang=js&"
export * from "./ForumArticles1.vue?vue&type=script&lang=js&"
import style0 from "./ForumArticles1.vue?vue&type=style&index=0&id=3fbaf2e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbaf2e6",
  null
  
)

export default component.exports